import type { ErrorCode } from '@/constants/error';
import { create } from 'zustand';
import { combine } from 'zustand/middleware';

export const defaultBizState = {
  // form data
  email: '',
  phone: '',
  authType: 'email' as AuthType, // 'email' | 'phone'
  areaCode: '+1',

  // used for register form
  firstName: '',
  lastName: '',
  country: 'us',
  authcode: '',

  // used for google captcha
  googleVersion: '3',

  // login state
  userName: '',
  callBack: '',

  // ...
  code: '',
  enablePassKey: false,
  roam: false,
  mfaCode: '',
  tempCode: '',
  signInBlocked: false,
  password: '',
  appName: '',
  autoLoginState: true,
  // oauth grant auth type, should be "-1 0 1 2"
  oauthGrantAuthType: '-1',

  // register reset recovery done: next steps...
  setupPwdDoneNextStep: '',

  mfa: {
    loginUserName: '',
    loginAreaCode: '',
    userName: '',
    areaCode: '',
    mfaType: 0,
    tempCode: '',
  } as MFAFlowProps,

  // social login authorize state
  socialAuthorizing: false,
  socialAuthRedirecting: false,

  errorCode: undefined as ErrorCode | undefined,
};

export type BizState = typeof defaultBizState;

export const useBizStore = create(combine(defaultBizState, (set) => ({ setBizState: set })));
